export default __webpack_public_path__ + "static/media/signUpBackground.24bfc745.png";